import { FunctionalComponent} from 'preact';
import { useState } from 'preact/hooks';
import { useSelector } from 'react-redux';

import { preloadPicture } from '../ui/slice/utils';
import { selectNtpVisitCounter } from '../user/slice';

import styles from './styles.module.scss';
import { selectUiMode } from '../../store/selectors';

const selectLogo = (state) => {
  const counter = selectNtpVisitCounter(state);
  return (counter % 6) + 1;
};

const APP_PLATFORM = process.env.APP_PLATFORM;

const Logo: FunctionalComponent = () => {
  const logo = useSelector(selectLogo);
  const [animateLogo, setAnimateLogo] = useState(null);
  const uiMode = useSelector(selectUiMode);

  const animatedLogoSrc = `img/whale/${logo}.png`;

  const handleMouseOver = () => {
    if (animateLogo || APP_PLATFORM === 'web' || uiMode === 'focus') return;
    preloadPicture(animatedLogoSrc).then(() => {
      setAnimateLogo(true);
    });
  };

  return (
    <div className={styles.logo} onMouseOver={handleMouseOver}>
      <img
        className={styles.logoWhale}
        src={animateLogo ? animatedLogoSrc : 'img/logo-whale.png'}
        alt="logo whale"
      />

      <img className={styles.logoText} src="img/logo-text.png" alt="logo" />
    </div>
  );
};

export default Logo;
